import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { find, hasClass } from '@fretadao/f-js-dom';
import { isPresent } from '@fretadao/f-js-utils';
import Cleave from 'cleave.js';
import 'cleave.js/dist/addons/cleave-phone.br.js';

application.register('mask', class extends Controller {
  static get targets() {
    return ['icon', 'cpf', 'cnpj', 'phone', 'postalCode', 'onlyNumber', 'money', 'hour'];
  }

  connect() {
    if (this.hasCpfTarget) this.maskCpfInputs();
    if (this.hasCnpjTarget) this.maskCnpjInputs();
    if (this.hasPostalCodeTarget) this.postalMaskInputs();
    if (this.hasPhoneTarget) this.maskPhoneInputs();
    if (this.hasOnlyNumberTarget) this.maskOnlyNumber();
    if (this.hasMoneyTarget) this.maskMoney();
    if (this.hasHourTarget) this.maskHour();
  }

  maskCpfInputs() {
    this.cpfTargets.forEach(target => {
      new Cleave(
        target,
        {
          blocks: [3, 3, 3, 2],
          numericOnly: true,
          delimiters: ['.', '.', '-']
        }
      );
    });
  }

  maskCnpjInputs() {
    this.cnpjTargets.forEach(target => {
      new Cleave(
        target,
        {
          blocks: [2, 3, 3, 4, 2],
          numericOnly: true,
          delimiters: ['.', '.', '/', '-']
        }
      );
    });
  }

  postalMaskInputs() {
    this.postalCodeTargets.forEach(target => {
      new Cleave(
        target,
        {
          blocks: [5, 3],
          numericOnly: true,
          delimiters: ['-']
        }
      )
    });
  }

  maskPhoneInputs() {
    this.phoneTargets.forEach(target => {
      new Cleave(
        target,
        {
          phone: true,
          phoneRegionCode: 'BR'
        }
      )
    });
  }

  maskOnlyNumber() {
    this.onlyNumberTargets.forEach(target => {
      const hasMaxLength = isPresent(target.maxLength) && Number(target.maxLength) > 0;

      new Cleave(
        target,
        {
          blocks: [hasMaxLength ? target.maxLength : 11],
          numericOnly: true
        }
      )
    });
  }

  maskMoney() {
    this.moneyTargets.forEach(target => {
      new Cleave(
        target,
        {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          numeralDecimalMark: ',',
          delimiter: '.',
          numeralDecimalScale: 2,
          numeralPositiveOnly: true
        }
      )
    });
  }

  maskHour() {
    this.hourTargets.forEach(target => {
      new Cleave(target, {
        delimiters: [':'],
        blocks: [2, 2],
        numericOnly: true,
        onValueChanged: ({ target: { value } }) => {
          const [hours, minutes] = value.split(':');
          if (hours > 23 || minutes > 59) {
            target.value = value.slice(0, -1); // Remove the last invalid character
          }
        },
      });
    });
  }

  togglePassword() {
    const passwordIcon = this.iconTarget;
    const passwordField = find(passwordIcon.dataset.fieldId);

    this.togglePasswordFieldAttribute(passwordField);

    this.toggleClasses(passwordIcon, 'fa-eye', 'fa-eye-slash');
  }

  togglePasswordFieldAttribute(field) {
    const fieldType = field.getAttribute('type') === 'password' ? 'text' : 'password'

    field.setAttribute('type', fieldType)
  }

  toggleClasses(element, classFrom, classTo) {
    if(hasClass(element, classFrom)) {
      element.classList.remove(classFrom)
      element.classList.add(classTo)
    } else if(hasClass(element, classTo)) {
      element.classList.remove(classTo)
      element.classList.add(classFrom)
    }
  }
});
